module.exports = __webpack_public_path__ + "static/img/governance.9f7aadb1.png";